import * as React from "react";

function SvgHomeBackground(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 567 540"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x={66}
        y={116}
        width={501}
        height={423}
        rx={24}
        fill="#B1C2FC"
        fillOpacity={0.23}
      />
      <ellipse
        cx={283}
        cy={317.5}
        rx={158}
        ry={150.5}
        fill="#0F2DCA"
        fillOpacity={0.7}
      />
      <ellipse cx={252} cy={330.5} rx={127} ry={121.5} fill="#fff" />
      <ellipse
        cx={247}
        cy={313.5}
        rx={49}
        ry={45.5}
        fill="#fff"
        fillOpacity={0.2}
      />
      <ellipse
        cx={453}
        cy={214}
        rx={104}
        ry={99}
        fill="#E8EBFF"
        fillOpacity={0.2}
      />
      <ellipse
        cx={508}
        cy={480}
        rx={57}
        ry={59}
        fill="#8796E4"
        fillOpacity={0.3}
      />
      <circle cx={390} cy={452} r={26} fill="#FDFDFF" fillOpacity={0.2} />
      <rect
        x={548}
        y={439}
        width={82}
        height={81}
        rx={8}
        transform="rotate(90 548 439)"
        fill="#2054BC"
        fillOpacity={0.3}
      />
      <rect
        x={197}
        y={278}
        width={19}
        height={19}
        rx={9.5}
        fill="#DD39AF"
        fillOpacity={0.05}
      />
      <rect
        x={197}
        y={300}
        width={19}
        height={19}
        rx={9.5}
        fill="#DD39AF"
        fillOpacity={0.2}
      />
      <rect
        x={224}
        y={300}
        width={18}
        height={19}
        rx={9}
        fill="#DD39AF"
        fillOpacity={0.05}
      />
      <rect
        x={197}
        y={322}
        width={19}
        height={18}
        rx={9}
        fill="#DD39AF"
        fillOpacity={0.3}
      />
      <rect
        x={224}
        y={322}
        width={18}
        height={18}
        rx={9}
        fill="#DD39AF"
        fillOpacity={0.2}
      />
      <rect
        x={252}
        y={322}
        width={17}
        height={18}
        rx={8.5}
        fill="#DD39AF"
        fillOpacity={0.05}
      />
      <rect
        x={197}
        y={344}
        width={19}
        height={18}
        rx={9}
        fill="#DD39AF"
        fillOpacity={0.7}
      />
      <rect
        x={224}
        y={344}
        width={18}
        height={18}
        rx={9}
        fill="#DD39AF"
        fillOpacity={0.3}
      />
      <rect
        x={252}
        y={344}
        width={17}
        height={18}
        rx={8.5}
        fill="#DD39AF"
        fillOpacity={0.2}
      />
      <rect
        x={277}
        y={344}
        width={19}
        height={18}
        rx={9}
        fill="#DD39AF"
        fillOpacity={0.05}
      />
      <rect
        x={197}
        y={366}
        width={19}
        height={18}
        rx={9}
        fill="#DD39AF"
        fillOpacity={0.9}
      />
      <rect
        x={224}
        y={366}
        width={18}
        height={18}
        rx={9}
        fill="#DD39AF"
        fillOpacity={0.7}
      />
      <rect
        x={252}
        y={366}
        width={17}
        height={18}
        rx={8.5}
        fill="#DD39AF"
        fillOpacity={0.3}
      />
      <rect
        x={277}
        y={366}
        width={19}
        height={18}
        rx={9}
        fill="#DD39AF"
        fillOpacity={0.2}
      />
      <rect
        x={301}
        y={366}
        width={20}
        height={18}
        rx={9}
        fill="#DD39AF"
        fillOpacity={0.05}
      />
      <rect
        x={379}
        y={143}
        width={143}
        height={142}
        rx={10}
        fill="#E8EBFF"
        fillOpacity={0.3}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M566.661 269.572c0 148.881-126.851 269.572-283.33 269.572C126.851 539.144 0 418.453 0 269.572c0-56.474 18.253-108.893 49.451-152.206 10.555 22.448 25.978 46.847 43.158 46.847 31.816 0 49.853-46.525 49.853-92.743 0-18.38 53.349-20.633 81.137-20.004 4.675.914 8.556 1.456 11.185 1.456 10.959 0 3.415-1.126-11.185-1.456-23.196-4.536-65.956-18.234-72.525-20.356C190.554 11.247 235.562 0 283.331 0c156.479 0 283.33 120.692 283.33 269.572zm-84.882 26.584c0 95.82-81.645 173.497-182.358 173.497-100.713 0-182.358-77.677-182.358-173.497 0-95.819 81.645-173.496 182.358-173.496 100.713 0 182.358 77.677 182.358 173.496zM102.987 102.194a9.082 9.082 0 01-9.082 9.082 9.082 9.082 0 119.082-9.082z"
        fill="#D2D6FB"
      />
    </svg>
  );
}

export default SvgHomeBackground;
